import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'

import { Modal, Table, Tag } from 'antd'

import { apiFetch } from '../../../helpers/restRequest'
import { deserialize } from '../../../helpers/jsonApi'

const ACTION_COLORS = {
    reconciled: 'green',
    unreconciled: 'red',
    linked: 'blue'
}

const renderBankStatement = (record) => {
    const { action, bank_statement_number, previous_bank_statement_number } = record

    if (action === 'unreconciled') { return previous_bank_statement_number }
    if (previous_bank_statement_number && previous_bank_statement_number !== bank_statement_number) {
        return `${previous_bank_statement_number} → ${bank_statement_number}`
    }
    return bank_statement_number
}

// Reconcile history for one order payment detail. Fetches on open; the
// backend restricts this endpoint to super_admin/accounting, and the button
// opening this modal is gated by the same roles.
const ReconciliationLogsModal = ({ orderId, paymentDetailId, onClose }) => {
    const { t } = useTranslation()
    const [loading, setLoading] = useState(false)
    const [logs, setLogs] = useState([])

    useEffect(() => {
        if (!paymentDetailId) { return undefined }

        let active = true
        setLoading(true)
        setLogs([])
        apiFetch(`/orders/${orderId}/payment_details/${paymentDetailId}/reconciliation_logs`)
            .then((data) => {
                if (!active) { return }
                setLogs('error' in data ? [] : deserialize(data))
            })
            .finally(() => {
                if (active) { setLoading(false) }
            })

        return () => { active = false }
    }, [orderId, paymentDetailId])

    const columns = [
        {
            title: t('confirms:accounting.reconciliationLogs.date'),
            dataIndex: 'created_at',
            render: (value) => dayjs(value).format('D MMM YYYY HH:mm')
        },
        {
            title: t('confirms:accounting.reconciliationLogs.staff'),
            dataIndex: 'staff_name',
            render: (value) => value || t('confirms:accounting.reconciliationLogs.systemStaff')
        },
        {
            title: t('confirms:accounting.reconciliationLogs.source'),
            dataIndex: 'source',
            render: (value) => t(`confirms:accounting.reconciliationLogs.sources.${value}`)
        },
        {
            title: t('confirms:accounting.reconciliationLogs.action'),
            dataIndex: 'action',
            render: (value) => (
                <Tag color={ACTION_COLORS[value]}>
                    {t(`confirms:accounting.reconciliationLogs.actions.${value}`)}
                </Tag>
            )
        },
        {
            title: t('confirms:accounting.reconciliationLogs.bankStatement'),
            render: (record) => renderBankStatement(record)
        }
    ]

    return (
        <Modal
            open={Boolean(paymentDetailId)}
            title={t('confirms:accounting.reconciliationLogs.title')}
            onCancel={onClose}
            footer={null}
            width="720px"
        >
            <Table
                rowKey="id"
                columns={columns}
                dataSource={logs}
                loading={loading}
                pagination={false}
                size="small"
            />
        </Modal>
    )
}

export { ReconciliationLogsModal }
